export const blockIconsEditorPieChart = (
	<span className='material-symbols-outlined'>pie_chart</span>
);
